module.exports = __webpack_public_path__ + "static/media/SS.34536ac3.webp";